(function() {
    'use strict';

    angular
        .module('quantixApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth'];

    function ResetFinishController ($stateParams, $timeout, Auth) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.resetAccount = {};
        vm.success = null;
        vm.badrequest=false;
       vm.exist=false;
       var randmnum=0;
        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else if($stateParams.key!=null) {
            	if($stateParams.key.length==20){
            		 vm.badrequest=false;
            		 vm.exist=false;
            		 randmnum=Math.random();
            		 var password=Auth.encryptPassword(vm.resetAccount.password+"_"+randmnum);
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword:password,passCheck:randmnum }).then(function (response) {
                	if(response[0]==='A'){
                		 vm.success =null;
                		vm.error = null;
                		vm.exist=true;
                	}else{
                    vm.success = 'OK';
                    vm.error = null;}
                })["catch"](function (response) {
                	 vm.username=false;
                     vm.pattern=false;
                     vm.isLastFivePassword=false;
                	 if(response.data==='Username should not be in password'){
                		 vm.username=true;
                	 }else if(response.data==='Invalid password format'){
                         vm.pattern=true;
                	 }else if(response.data==='Password cannot be from last 5 passwords'){
                        vm.isLastFivePassword=true;
                     }else if(response.status==400){
                		 vm.success = null;
                         vm.error = null;
                    	 vm.badrequest=true;
                	}
                	if(response.status==500){
                    vm.badrequest=false;
                    vm.success = null;
                    vm.error = 'ERROR';
                	}
                });
             } else{
            	 vm.exist=false;
            	 vm.success = null;
                 vm.error = null;
            	 vm.badrequest=true;
             }
           }else{
        	   vm.exist=false;
        	   vm.success = null;
               vm.error = null;
            	vm.badrequest=true;
           }
        }
    }
})();
